// extracted by mini-css-extract-plugin
export var callCard = "_ov-0";
export var callMessageButton = "_ov-1";
export var helpIcon = "_ov-3";
export var helpIconContainer = "_ov-4";
export var verticalDivider = "_ov-2";